// JsFromRoutes CacheKey 3707027cbb495e7a1ab5df514f8bac48
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/nps/internal/test_surveys'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/nps/internal/test_surveys'),
}
